import React, { useState, useEffect, useContext } from 'react';
//import 'bulma/css/bulma.min.css';
import '../view-archer-styles.css';

// material-ui: theme, colors, icons
import {Button, Chip, Divider, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, Slide, Stack, Typography } from '@mui/material/';
import { TransitionProps } from '@mui/material/transitions';
import { deepOrange, green, pink, blue, red } from '@mui/material/colors';
import { Close} from '@mui/icons-material/';

//components import
import ArcherLetter from '../dataObjects/ArcherLetter';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import AlertInfo from '../../../dataObjects/AlertInfo';
import { AuditorCommunicationContext } from '../view-archer';

interface Props{
    isPreviewDialogOpen: boolean,
    letterId: number,
    closePreviewDialog: () => void;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />;
});


const DashboardPreviewDraftLetter = (props: Props) => {

    //initial state setup
    const [archerLetter, setLetter] = useState<ArcherLetter>();
    const [letterContent, setLetterContent] = useState('');
    const [confirmActionData, setConfirmationAction] = useState({
        type: '',
        id: props.letterId
    })

    useEffect(() => {
        if (props.letterId>0) {
            getArcherLetter();
            getLetterPreview();
        }
    }, [props.letterId]);

    const closePreviewDialog = () => {
        setLetterContent('');
        props.closePreviewDialog();
    }

    /*Edit the letter*/
    const context = useContext(AuditorCommunicationContext);

    const setCurrentCpfIdAndLetterId = (cpfId: number, letterId: number) => {
        context.setCurrentLetterCpfId(cpfId);
        context.setCurrentLetterId(letterId);
        props.closePreviewDialog();
    }

    const getArcherLetter = async () => {
        let url = `/archer3/GetLetter?letterId=${props.letterId}`;
        await fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: GetLetter',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    let data = result.result;
                    setLetter(data);
                }

            })
    }

    const getLetterPreview = async () => {
        var params = [
            `letterId=${props.letterId}`,
        ].join('&');

        let url = `/Archer3/GetLetterPreview?${params}`;

        await fetch(url)
            .then(result => result.text())
            .then(result => {
                let html = result;
                setLetterContent(html);
            })
    }

    const confirmSendLetter = (letterDate: string) => {
        let today = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
        if (new Date(letterDate).getTime() !== new Date(today).getTime()) {
            let info = {
                type: 'confirm',
                title: "Confirm: Update to today's date",
                buttonLabel: "Yes",
                errorMessage: "This letter's date is not today, would you like to update its date to today?",
                secondaryErrorMessage: ''
            };

            let action = {
                type: 'sendLetter',
                id: props.letterId
            }

            setConfirmationAction(action);
            setAlertInfo(info);
            setAlertInfoDialog(true);
        }
        else {
            sendLetter(false, false);
            setLetterContent('');
            props.closePreviewDialog();
        }
    }

    const sendLetter = (updateDate: boolean, toMe: boolean) => {

        var params = [
            `letterId=${props.letterId}`,
            `toMe=${toMe}`,
            `changeDateToToday=${updateDate}`,
            `overrideWarnings=${!updateDate}`
        ].join('&');
        let url = `/Archer3/SendLetter?${params}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: SendLetter',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {

                    let successMessage = toMe ? 'Email successfully sent to yourself!' : 'Email successfully sent!';

                    let info = {
                        type: 'success',
                        title: 'Email sent',
                        errorMessage: successMessage,
                        secondaryErrorMessage: ''
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                    setLetterContent('');
                    props.closePreviewDialog();
                }
            })
    }

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    const confirmAction = (confirm: boolean) => {
        let type = confirmActionData.type;
        let id = confirmActionData.id;
        if (confirm) {
            switch (type) {
                case 'sendLetter':
                    sendLetter(true, false);
                    break;
            }
        }
        else {
            switch (type) {
                case 'sendLetter':
                    // not update to today's date, not to me
                    sendLetter(false, false);
                    break;
            }
        }
    }

    return (
        <div>
            {
                archerLetter &&
                <Dialog
                    open={props.isPreviewDialogOpen}
                    scroll={'paper'}
                    fullWidth={true}
                    maxWidth={'md'}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={closePreviewDialog}
                    sx={{
                        "& .MuiDialog-container": {
                            justifyContent: "flex-end",
                            alignItems: "flex-end"
                        }
                    }}
                    PaperProps={{
                        sx: {
                            m: 0,
                            top: 0,
                            right: 0,
                            bottom: 0,
                            minHeight: '100vh'
                        }
                    }}
                >
                    <DialogTitle>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Chip label="Draft" color="warning" />
                            <Chip label="Preview" variant="outlined" color="primary" />
                            <Typography variant="subtitle1" sx={{ color: blue[800] }}>
                                {archerLetter.filerDisplayName}
                            </Typography>
                                <Typography variant="subtitle2" sx={{ color: blue[800] }}>{archerLetter.date} {archerLetter.letterTemplateCode}</Typography>
                        </Stack>
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={closePreviewDialog}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                    <DialogContent dividers>
                        <Grid container sx={{ marginTop: 1 }}>
                            <Grid item xs={6}>
                                <Stack direction="row" spacing={2}>
                                    <Typography variant="subtitle1" sx={{ color: blue[800] }}>Subject</Typography>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{archerLetter.subject}</Typography>
                                </Stack>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ marginTop: 1 }}>
                            <Grid item xs={12}>
                                    <Stack direction="row" spacing={1}>
                                        <Typography variant="subtitle1" sx={{ color: blue[800] }}>Recipients</Typography>
                                        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                                            {
                                                archerLetter.recipients.map((recipient) =>
                                                    <Chip key={recipient.id} label={`${recipient.isPrimaryRecipient ? 'To' : 'Cc'}: ${recipient.firstName} ${recipient.lastName} (${recipient.emailAddress})`} variant="outlined" color="primary" />
                                                )
                                            }
                                        </Stack>
                                </Stack>
                            </Grid>
                        </Grid>
                        <Divider light sx={{ marginTop: 3, marginBottom: 3 }} />
                        <DialogContentText className="letter-preview-content" dangerouslySetInnerHTML={{ __html: letterContent }}></DialogContentText>
                    </DialogContent>
                      <DialogActions>
                        <Button onClick={() => confirmSendLetter(archerLetter.date)} variant="contained" color="success">Send</Button>
                        <Button variant="contained" color="primary" onClick={() => setCurrentCpfIdAndLetterId(archerLetter.cpfId, archerLetter.id)} >Edit</Button>
                        <Button onClick={closePreviewDialog} variant="contained" color="warning">Cancel</Button>
                      </DialogActions>
                </Dialog>
            }
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog} confirmAction={confirmAction}></AlertInfoDialog>
            }
        </div>
    )
}

export default DashboardPreviewDraftLetter;